<template>
  <div>
    <v-layout row>
      <v-select v-model="clubPerteneceALPF" :items="opcionesClubDestino" :error-messages="destinoErrors" label="El club de destino pertenece a LPF"
                required no-data-text="No hay datos disponibles"></v-select>
      <v-autocomplete class="selector-club-lpf" v-model="clubDestino" :items="clubes" :error-messages="clubError" label="Club destino" item-text="nombre" item-value="pk"
        required no-data-text="No hay datos disponibles" v-if="clubPerteneceALPF"></v-autocomplete>
        <v-text-field class="selector-club-lpf"  v-if="!clubPerteneceALPF" v-model="clubDestinoNoLpf" :error-messages="clubNoLpfError" label="Club destino "></v-text-field>
        <slot></slot>
    </v-layout>
  </div>
</template>
<script>
import { requiredIf } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'

export default {
  mixins: [validationMixin],
  validations () {
    return {
      clubDestino: { required: requiredIf(() => { return this.clubPerteneceALPF }) },
      clubPerteneceALPF: { required: requiredIf(() => { return this.isRequired }) },
      clubDestinoNoLpf: { required: requiredIf(() => { return !this.clubPerteneceALPF }) }

    }
  },
  props: {
    isRequired: Boolean
  },
  data () {
    return {
      clubPerteneceALPF: null,
      clubes: null,
      clubDestino: null,
      opcionesClubDestino: [
        {
          text: 'El club de destino pertenece a LPF',
          value: true
        },
        {
          text: 'El club de destino no pertenece a LPF',
          value: false
        }
      ],
      clubDestinoNoLpf: null
    }
  },
  computed: {
    clubError () {
      const errors = []
      if (!this.$v.clubDestino.$dirty) return errors
      !this.$v.clubDestino.required && errors.push('El club es requerido.')
      return errors
    },
    destinoErrors () {
      return this.getRequiredErrors('clubPerteneceALPF')
    },
    clubNoLpfError () {
      const errors = []
      if (!this.$v.clubDestinoNoLpf.$dirty) return errors
      !this.$v.clubDestinoNoLpf.required && errors.push('El club es requerido.')
      return errors
    }
  },
  methods: {
    fetchClubes () {
      this.axios
        .get('/otros-clubes')
        .then(response => {
          this.loadingSeasons = false
          this.clubes = response.data
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
        })
    },
    getRequiredErrors (property, message = 'Este campo es requerido.') {
      const errors = []
      const formComponent = property.includes('.') ? this.$v[property.split('.')[0]][property.split('.')[1]] : this.$v[property]
      if (!formComponent.$dirty) return errors
      !formComponent.required && errors.push(message)
      return errors
    }
  },
  created () {
    this.fetchClubes()
  }
}
</script>
<style scoped>
.selector-club-lpf {
  width: 100%;
  margin-left: 1em;
}
</style>
